import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Message from 'components/Message';
import When from 'components/When';
import { bem } from 'helpers/class-name';

import { SELECTION_ROW_TYPE } from '../Modifiers.itemSelection';
import messages from './ModifierItemPicker.messages';

const { element } = bem('modifier-item-picker');

const ModifierSelectionRows = ({ rows, onRemove, onReview, disabled }) => {
  const intl = useIntl();

  const rowText = row => (
    <>
      <span className={element('selection-name')}>{row.name}</span>
      <span className={element('selection-detail')}>
        {row.type === SELECTION_ROW_TYPE.MENU ? (
          <Message message={messages.usedInItems} values={{ count: row.itemCount }} />
        ) : (
          `${row.categoryName} · ${row.menuName}`
        )}
      </span>
    </>
  );

  return (
    <ul className={element('selection')}>
      {rows.map(row => {
        const isMenu = row.type === SELECTION_ROW_TYPE.MENU;

        return (
          <li key={`${row.type}-${row.id}`} className={element('selection-row', { menu: isMenu })}>
            {isMenu ? (
              // Stays clickable in read-only: the review dialog is how a partner sees which
              // items a collapsed menu covers, and the dialog itself renders view-only there.
              <button
                type="button"
                className={element('selection-review')}
                aria-label={intl.formatMessage(messages.reviewMenuAriaLabel, { name: row.name })}
                onClick={() => onReview(row)}>
                {rowText(row)}
              </button>
            ) : (
              <div className={element('selection-text')}>{rowText(row)}</div>
            )}
            <When predicate={!disabled}>
              <button
                type="button"
                className={element('selection-remove')}
                aria-label={intl.formatMessage(isMenu ? messages.removeAllAriaLabel : messages.removeItemAriaLabel, {
                  name: row.name,
                })}
                onClick={() => onRemove(row)}>
                <Message message={isMenu ? messages.removeAllSelection : messages.removeSelection} />
              </button>
            </When>
          </li>
        );
      })}
    </ul>
  );
};

ModifierSelectionRows.propTypes = {
  disabled: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  onReview: PropTypes.func.isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, type: PropTypes.string })).isRequired,
};

export default ModifierSelectionRows;
